import { useService } from "@policoders/di";
import { ISelectOptions } from "@policoders/ds";
import { useEffect, useState } from "react";

import formatHelper from "../../../../../core/helpers/formatHelper";
import { MeasureUnitType } from "../../../types/measure-unit.type";
import ProductRepository from "../../stock/products/product.repository";
import { TechnicalSheetItem } from "../technical-sheet.model";
import { TechnicalSheetStore } from "../technical-sheet.store";

export type ITechnicalSheetItemFormProps = {
  data: TechnicalSheetItem;
  action: "new" | "edit";
};

export const useTechnicalSheetItemForm = ({ data }: ITechnicalSheetItemFormProps) => {
  const [state, setState] = useState<TechnicalSheetItem>(data);
  const store = useService<TechnicalSheetStore>("TechnicalSheetStore");

  const productRepository = useService<ProductRepository>("ProductRepository");
  const [products, setProducts] = useState<ISelectOptions[]>([]);

  const handleChange = (e: any) => {
    setState({
      ...state,
      groupItem: state.groupItem ?? "Receita",
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    store.updateCurrentItem(state);
  }, [state, store]);

  useEffect(() => {
    productRepository.getAll();
    const subscriber = productRepository.data$.subscribe(data => {
      setProducts([
        { label: "", value: "" },
        ...data.map(d => ({
          label: `${d.productName} (${formatHelper.measure(d.unit)} ${d.measureUnit})`,
          value: d.id,
        })),
      ]);
    });
    return () => {
      subscriber.unsubscribe();
    };
  }, [productRepository, store]);

  const getProductValue = () => {
    const _default: ISelectOptions = { label: "loading...", value: state.productId };
    if (products.length === 0) return _default;
    const item = products.find(p => p.value === state.productId);
    return item ?? _default;
  };

  const measureUnitTypes = (): ISelectOptions[] => {
    var items = Object.keys(MeasureUnitType);
    var values = Object.values(MeasureUnitType);
    return [
      ...items.map((item, i) => ({
        label: item.replace("_", " "),
        value: values[i],
      })),
    ];
  };

  return { state, products, getProductValue, measureUnitTypes, handleChange };
};
